import { FCWithChildren } from '@types';
import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';

import { INetworkInfo, IInvitee, getReceivedInvites, IReceivedInvitation } from 'sdk-apogee';

import { ActionTypes } from '../SharedList';
import Invite from './Invite';

type InvitesProps = {
  myNetworkStatus: INetworkInfo | null | undefined;
  dispatch: (action: ActionTypes) => void;
  sent?: boolean;
  received?: boolean;
};

const Invites: FCWithChildren<InvitesProps> = ({ myNetworkStatus, sent, received, dispatch }) => {
  const { data: receivedInvites } = useSuspenseQuery<IReceivedInvitation[]>({
    queryKey: ['received-invites'],
    // @ts-ignore
    queryFn: getReceivedInvites,
  });

  // Everyone the host has invited — both those still pending and those who joined.
  const sentInvites = myNetworkStatus ? myNetworkStatus.invitations : [];

  const awaitingResponse = receivedInvites
    ? receivedInvites
        // @ts-ignore
        .filter(({ accepted }) => !accepted)
        .map(({ id, ownerId, ownerName, ownerEmail, invitations }) => ({
          accountId: ownerId,
          accountName: ownerName,
          accountEmail: ownerEmail,
          id: id,
          invitations,
        }))
    : [];

  return (
    <>
      {sent && !!sentInvites?.length && (
        <Invite
          title="My Shared Network Invites"
          list={sentInvites as IInvitee[]}
          variant="sent"
          dispatch={dispatch}
        />
      )}
      {received && !!awaitingResponse?.length && (
        <Invite
          title="Join Shared Network"
          list={awaitingResponse as IReceivedInvitation[]}
          variant="received"
          dispatch={dispatch}
        />
      )}
    </>
  );
};

export default Invites;
